export const GSPINVESCO = 'gspinvesco';